"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flex = void 0;
var flex_1 = require("./flex");
Object.defineProperty(exports, "Flex", { enumerable: true, get: function () { return flex_1.Flex; } });
//# sourceMappingURL=index.js.map